import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ArrowRight, ClockPlus, HandCoins, DollarSign, Contact, BookLock, ChartNoAxesCombined, ChartNoAxesColumnIncreasing, MapPinned, Receipt, ContactRound, Combine, ChevronLeft as ChevLeft, ChevronRight as ChevRight, FileText, CreditCard, Link2, Wand2, ShieldAlert, GripVertical, UserCircle, ShieldCheck, Filter, Navigation, LayoutDashboard, FileSpreadsheet, Calculator, CalendarClock, FileCheck, Bell, MessageSquareText, FileBarChart, Plus, Check, CheckCircle2, Clock3, Eye, Mail, MoreVertical, Send, TrendingUp, CalendarDays, Download, MapPin, Upload, UserRound, Sparkles, AlertTriangle, ChevronDown, ChevronRight, ClipboardList, BookOpen, Headphones } from 'lucide-react';
import { SiAdp, SiG2, SiGmail, SiGoogledrive, SiGoogleforms, SiGooglesheets, SiQuickbooks, SiTrustpilot, SiWhatsapp } from 'react-icons/si';
import { PiMicrosoftOutlookLogoFill, PiMicrosoftExcelLogoFill, PiMicrosoftWordLogoFill, PiMicrosoftTeamsLogoFill } from 'react-icons/pi';
import { FaSlack, FaUsers } from 'react-icons/fa';
import { Modal, Rating, Tooltip } from '@mui/material';
import { BiLogoAdobe } from 'react-icons/bi';
import { FaFilePdf } from 'react-icons/fa6';
import { LandingNavigation } from '../Components/landing-navigation';
import { WorkyMainDemo } from '../Components/WorkyMainDemo/WorkyMainDemo';
import { WorkyMainDemoMobile } from '../Components/WorkyMainDemo/WorkyMainDemoMobile';
import { useIsMobile } from '../../custom-hooks/useIsMobile';
import { openWorkyCalendlyDemoInNewTab } from '../../analytics/openWorkyCalendlyDemo';
import { useSnackbar } from 'notistack';
import { TurnstileWidget } from '../Components/TurnstileWidget';
import {
    HOT_INTAKE_BLOCKED_EMAIL_SNACKBAR,
    HOT_INTAKE_HOW_CAN_WE_HELP_FIRST_CLICK,
    isBlockedHotIntakeEmailDomain,
    isValidHotIntakeEmail,
    navigateToContactSalesPage,
    navigateToContactSalesPageWithEmail,
} from '../Components/HotIntakeLeadFormShared';
import { scrollToSection } from '../../utils/scrollToSection';
import { OPERATIONS_SEO_FAQS, landingPageSeoByPath } from '../seo/LandingPageSeoConfig';
import { useLandingPageSeo } from '../seo/useLandingPageSeo';
import { WORKY_WEB_APP_PATHS } from '../../WorkyWebAppPaths';
import { LPFooter } from './LandingPage';
import { SalesTrackerHotIntakeReqDTO } from '../../splashComponent/sales-related/sales-related-data/SalesTrackerHotIntakeInterfaces';
import { SalesTrackerHotIntakeAPICall } from '../../splashComponent/sales-related/sales-related-api/SalesTrackerAPICalls';
import {
    LOCAL_STORAGE_KEYS,
    RetrieveFromLocalCache,
    isValidString,
} from '../../common/CommonUtilsMethods';


import {
    InvoicingContainer,
    WorkyPayContainer,
    TimeClockContainer,
    SmartMatchContainer,
    WorkforceContainer,
    TrustVaultContainer,
    SideNavigationBar,
    OperationsProductModal,
    OperationsHero,
    OPERATIONS_SECTION_IDS,
    OPERATIONS_PAGE_CONTENT_CLASS,
    OPERATIONS_SCROLL_ALLOWED_PATHS,
    isOperationsLandingPath,
    OperationsMakeTheSwitchButton,
} from './LandingPageProductsOperations';
import { OperationsProductKey } from './operationsProductCatalog';
import '../Styling/landingPage.css';
import '../Styling/landingPageSales.css';
import '../Styling/landingPageMarketplace.css';
import '../Styling/landingPageOperations.css';
import '../Styling/landingPageOperationsSeo.css';

import {
    InvoicingSelectionIllustration,
    WorkypaySelectionIllustration,
    SmartMatchSelectionIllustration,
    TimeClockSelectionIllustration,
    WorkforceSelectionIllustration,
    TrustVaultSelectionIllustration,
} from './LandingPageProductsOperationsSelectionComponents';

const OPERATIONS_SEO_PATH: string = WORKY_WEB_APP_PATHS.landingPageOperationsSeo;
const OPERATIONS_SEO_PAGE_CLASS: string = `${OPERATIONS_PAGE_CONTENT_CLASS} landing-page-operations-seo`;

interface OperationsSeoFeatureItem {
    readonly label: string;
    readonly sectionId?: string;
    readonly icon: React.ReactNode;
}

const OPERATIONS_SEO_FEATURES: readonly OperationsSeoFeatureItem[] = [
    { label: 'Shift scheduling', sectionId: 'smart-match', icon: <CalendarDays size={15} /> },
    { label: 'Care plans', icon: <ClipboardList size={15} /> },
    { label: 'Invoicing', sectionId: 'invoicing', icon: <Receipt size={15} /> },
    { label: 'Payroll', sectionId: 'worky-pay', icon: <HandCoins size={15} /> },
    { label: 'Worker compliance', sectionId: 'trust-vault', icon: <ShieldCheck size={15} /> },
    { label: 'Time clock', sectionId: 'time-clock', icon: <MapPinned size={15} /> },
    { label: 'EVV', sectionId: 'time-clock', icon: <MapPin size={15} /> },
];

interface OperationsSeoFeatureSetProps {
    readonly isMobile: boolean;
}

const OperationsSeoFeatureSet = ({ isMobile }: OperationsSeoFeatureSetProps): React.JSX.Element => {
    const handleFeatureClick = (sectionId: string | undefined): void => {
        if (!sectionId) {
            return;
        }
        scrollToSection({
            sectionId,
            allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS],
            offset: isMobile ? 70 : 80,
            behavior: 'smooth',
        });
    };

    return (
        <span className="lpops-seo-feature-set">
            {OPERATIONS_SEO_FEATURES.map((feature: OperationsSeoFeatureItem, index: number): React.JSX.Element => (
                <React.Fragment key={feature.label}>
                    {index > 0 ? <span className="lpops-seo-feature-sep" aria-hidden="true">  </span> : null}
                    <button
                        type="button"
                        className="lpops-seo-feature-chip"
                        onClick={(): void => handleFeatureClick(feature.sectionId)}
                    >
                        <span className="lpops-seo-feature-chip-icon" aria-hidden="true">{feature.icon}</span>
                        {feature.label}
                    </button>
                </React.Fragment>
            ))}
        </span>
    );
};

interface OperationsSeoHeroProps {
    readonly isMobile: boolean;
}

const OperationsSeoHero = ({ isMobile }: OperationsSeoHeroProps): React.JSX.Element => {
    const demoRef = useRef<HTMLDivElement>(null);
    const [demoRotation, setDemoRotation] = useState<number>(32);
    const [isHoveringDemo, setIsHoveringDemo] = useState<boolean>(false);
    const [tiltX, setTiltX] = useState<number>(0);
    const [tiltY, setTiltY] = useState<number>(0);

    useEffect((): (() => void) => {
        const handleScroll = (): void => {
            if (!demoRef.current) {
                return;
            }
            const rect: DOMRect = demoRef.current.getBoundingClientRect();
            const windowHeight: number = window.innerHeight;
            const scrollProgress: number = Math.max(
                0,
                Math.min(1, (windowHeight - rect.top) / (windowHeight * 0.75))
            );
            setDemoRotation(32 * (1 - scrollProgress));
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return (): void => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleDemoMouseMove = (event: React.MouseEvent<HTMLDivElement>): void => {
        if (!demoRef.current) {
            return;
        }
        const rect: DOMRect = demoRef.current.getBoundingClientRect();
        const normalizedX: number = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        const normalizedY: number = ((event.clientY - rect.top) / rect.height) * 2 - 1;
        const maxTilt: number = 1;
        setTiltX(-normalizedY * maxTilt);
        setTiltY(normalizedX * maxTilt);
    };

    const handleDemoMouseEnter = (): void => {
        setIsHoveringDemo(true);
    };

    const handleDemoMouseLeave = (): void => {
        setIsHoveringDemo(false);
        setTiltX(0);
        setTiltY(0);
    };

    const scrollToInvoicing = (): void => {
        scrollToSection({
            sectionId: 'invoicing',
            allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS],
            offset: isMobile ? 70 : 80,
            behavior: 'smooth',
        });
    };

    return (
        <>
        <OperationsHeroSEO isMobile={isMobile} />
        </>
    );
};

interface OperationsSeoOverviewProps {
    readonly isMobile: boolean;
}




const OperationsHeroSEO = ({ isMobile }: {isMobile: boolean}) => {
    const MainProductsContainer = ({isMobile}: {isMobile: boolean}) => {
        return(
            <div className={`lpsp-main-products-container lpsp-operations-main-products ${isMobile ? 'is-mobile' : ''}`}>
                    <div className={isMobile ? 'lp-blog-title-mobile' : 'lp-blog-title'}>The modern operating system for healthcare staffing software &amp; home care staffing software</div>
                    <div className={isMobile ? 'lpsp-hero-subtitle-mobile' : 'lpsp-hero-subtitle'}>Worky is the industry-leading all-in-one healthcare staffing software and home care staffing software platform, trusted by the fastest-growing businesses. </div>
                    <OperationsMakeTheSwitchButton isMobile={isMobile} />
                    <div className={isMobile ? 'lpsp-main-products-container-cards-mobile lpsp-operations-product-cards-mobile' : 'lpsp-main-products-container-cards lpsp-operations-product-cards'}>
    
                        
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'invoicing', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <InvoicingSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Receipt size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Invoicing</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Automated client billing—customized to every contract</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
             
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'worky-pay', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <WorkypaySelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><HandCoins size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Worky Pay</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Flexible payroll for your contractors and employees</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'smart-match', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <SmartMatchSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Combine size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Smart Match</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>AI-driven placement that never sleeps.</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'time-clock', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <TimeClockSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><MapPinned size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Time Clock</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Digital tracking driving automated pay & billing</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'workforce', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <WorkforceSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Contact size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Workyforce</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Centralized hub for every worker in your talent pool</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
                            <div 
                                className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
                                onClick={() => scrollToSection({ sectionId: 'trust-vault', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
                                style={{cursor: 'pointer'}}
                            >
                                                
                                <div className='lp-product-img-container'>
                                    <TrustVaultSelectionIllustration />
                                </div>
    
                                <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
                                    <div className='lp-product-label'>
                                        <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><BookLock size={isMobile ? 18 : 20} /></span>
                                        <span className='lp-product-label-text'>Trust Vault</span>
                                    </div>
                                    <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Secure credential and document management</div>
                                </div>
                                
                                <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                            
                            </div>
    
                {/* *************************************************************************************************************************************************************** */}
    
    
    
    
                    </div>
                </div>
        )
    }
    const demoRef = useRef<HTMLDivElement>(null);
    const [demoRotation, setDemoRotation] = useState<number>(32);
    const [isHoveringDemo, setIsHoveringDemo] = useState<boolean>(false);
    const [tiltX, setTiltX] = useState<number>(0);
    const [tiltY, setTiltY] = useState<number>(0);
    const [heroEmail, setHeroEmail] = useState<string>('');
    const [heroCaptchaToken, setHeroCaptchaToken] = useState<string | null>(null);
    const [heroTurnstileResetSignal, setHeroTurnstileResetSignal] = useState<number>(0);
    const [isHeroEmailSubmitting, setIsHeroEmailSubmitting] = useState<boolean>(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleHeroEmailCtaSubmit = async (
        submitEvent: React.FormEvent<HTMLFormElement>
    ): Promise<void> => {
        submitEvent.preventDefault();
        const trimmedHeroEmail: string = heroEmail.trim();

        if (isBlockedHotIntakeEmailDomain(trimmedHeroEmail)) {
            enqueueSnackbar(HOT_INTAKE_BLOCKED_EMAIL_SNACKBAR, { variant: 'error' });
            return;
        }
        if (!isValidHotIntakeEmail(trimmedHeroEmail)) {
            enqueueSnackbar('Please enter a valid email', { variant: 'error' });
            return;
        }

        setIsHeroEmailSubmitting(true);

        if (isValidString(heroCaptchaToken)) {
            const verifiedHeroCaptchaToken: string = heroCaptchaToken as string;
            const firstClickHotIntakePayload: SalesTrackerHotIntakeReqDTO = {
                workySessionId: RetrieveFromLocalCache(LOCAL_STORAGE_KEYS.WORKY_SESSION_ID),
                contactChannelValue: trimmedHeroEmail,
                captchaToken: verifiedHeroCaptchaToken,
                howCanWeHelp: HOT_INTAKE_HOW_CAN_WE_HELP_FIRST_CLICK,
                primaryServiceAreas: null,
                operatingTenure: null,
            };
            try {
                await SalesTrackerHotIntakeAPICall(firstClickHotIntakePayload);
            } catch (firstClickHotIntakeError: unknown) {
                console.error('FIRST_CLICK hot-intake failed:', firstClickHotIntakeError);
                setHeroTurnstileResetSignal((previousResetSignal: number): number => previousResetSignal + 1);
                setHeroCaptchaToken(null);
            }
        }

        navigateToContactSalesPageWithEmail(trimmedHeroEmail);
    };

    useEffect((): (() => void) => {
        const handleScroll = (): void => {
            if (!demoRef.current) return;
            const rect: DOMRect = demoRef.current.getBoundingClientRect();
            const windowHeight: number = window.innerHeight;
            const scrollProgress: number = Math.max(0, Math.min(1,
                (windowHeight - rect.top) / (windowHeight * 0.75)
            ));
            setDemoRotation(32 * (1 - scrollProgress));
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return (): void => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleDemoMouseMove = (e: React.MouseEvent<HTMLDivElement>): void => {
        if (!demoRef.current) return;
        const rect: DOMRect = demoRef.current.getBoundingClientRect();
        const normalizedX: number = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        const normalizedY: number = ((e.clientY - rect.top) / rect.height) * 2 - 1;
        const maxTilt: number = 1;
        setTiltX(-normalizedY * maxTilt);
        setTiltY(normalizedX * maxTilt);
    };

    const handleDemoMouseEnter = (): void => setIsHoveringDemo(true);

    const handleDemoMouseLeave = (): void => {
        setIsHoveringDemo(false);
        setTiltX(0);
        setTiltY(0);
    };

    return (
        <div className='lpsp-hero-container lpops-seo-rings-hero'>
            
            {/* 1. Background Animation Layer */}
            <div className='lpsp-background-layer'>
                <div className='lpsp-rings-center'>
                    
                    {/* Ring 1 - Smallest */}
                    <div className='lpsp-ring lpsp-ring-1'>
                        <div className='lpsp-orbiter orb-pos-1-1'><SiGooglesheets size={34} color='#0F9D58' /></div>
                        <div className='lpsp-orbiter orb-pos-1-2'><SiGoogledrive size={34} color='#4285F4' /></div>
                        <div className='lpsp-orbiter orb-pos-1-3'><SiQuickbooks size={37} color='#2CA01C' /></div>
                    </div>

                    {/* Ring 2 */}
                    <div className='lpsp-ring lpsp-ring-2'>
                        <div className='lpsp-orbiter orb-pos-2-1'><SiAdp size={37} color='#D7262D' /></div>
                        <div className='lpsp-orbiter orb-pos-2-2'><BiLogoAdobe size={34} color='#EC1C24' /></div>
                        <div className='lpsp-orbiter orb-pos-2-3'><PiMicrosoftWordLogoFill size={34} color='#2B579A' /></div>
                        <div className='lpsp-orbiter orb-pos-2-4'><SiWhatsapp size={34} color='#25D366' /></div>
                    </div>

                    {/* Ring 3 */}
                    <div className='lpsp-ring lpsp-ring-3'>
                        <div className='lpsp-orbiter orb-pos-3-1'><PiMicrosoftOutlookLogoFill size={34} color='#0078D4' /></div>
                        <div className='lpsp-orbiter orb-pos-3-2'><SiGoogleforms size={34} color='#673AB7' /></div>
                        <div className='lpsp-orbiter orb-pos-3-3'><SiGmail size={34} color='#EA4335' /></div>
                        <div className='lpsp-orbiter orb-pos-3-4'><PiMicrosoftExcelLogoFill size={34} color='#217346' /></div>
                        <div className='lpsp-orbiter orb-pos-3-5'><FaSlack size={34} color='#4A154B' /></div>
                    </div>

                        {/* Ring 4 - Largest */}
                        <div className='lpsp-ring lpsp-ring-4'>
                        <div className='lpsp-orbiter orb-pos-4-2'><PiMicrosoftTeamsLogoFill size={34} color='#6264A7' /></div>
                        <div className='lpsp-orbiter orb-pos-4-4'><FaFilePdf size={34} color='#FF0000' /></div>
                    </div>

                </div>
            </div>

            {/* 2. Fade Overlay Layer */}
            <div className='lpsp-fade-overlay'></div>

            {/* 3. Content Layer */}
            <div className='lpsp-hero-container-text-container'>
                {/* <div className={isMobile ? 'lpsp-hero-title-mobile' : 'lpsp-hero-title'}>Stop Using 50+ <br />Tools for Your Agency</div>
                <div className={isMobile ? 'lpsp-hero-subtitle-mobile' : 'lpsp-hero-subtitle'}>
                    Run your entire agency—from shifts to payroll to invoicing—on one platform
                </div>
                <button className={isMobile ? 'lpsp-hero-button-mobile' : 'lpsp-hero-button'}>Start Selling</button> */}

<div className={isMobile?'hero-section-text-mobile':'hero-section-text'}>
                    <h1
                        className={isMobile? 'hero-section-loop-text-mobile' : 'hero-section-loop-text'}
                    >
                        <span className="lpops-seo-hero-rank">#1</span>
                        <span className="text-loop-text">Home Care</span>
                        <span className="lpops-seo-hero-headline">Management Software</span>
                    </h1>
                    
                    <p className="lpops-seo-hero-benefit">Less admin. More time for care.</p>
                    <section className="lpops-seo-answer" aria-labelledby="lpops-seo-answer-heading">
                        <h2 id="lpops-seo-answer-heading">Healthcare staffing software for private homecare and healthcare staffing agencies</h2>
                        <p>Worky is healthcare staffing software for the owner or operations manager of a private homecare agency or a healthcare staffing agency.</p>
                        <p>The workflow is Shift, then TimeClock, then Pay, then Invoice.</p>
                    </section>
                    <h2 className={isMobile?'lph-subtitle-mobile':'lph-subtitle'}>
                        <OperationsSeoFeatureSet isMobile={isMobile} />
                        <span className="lpops-seo-hero-trust">
                            The Homecare software trusted by <span>1500+ Businesses</span>
                        </span>
                    </h2>
                    
                    <div className='lph-button-holder'>
                        <form
                            className={`lpops-seo-hero-email-cta${isMobile ? ' is-mobile' : ''}`}
                            onSubmit={(submitEvent: React.FormEvent<HTMLFormElement>): void => {
                                void handleHeroEmailCtaSubmit(submitEvent);
                            }}
                        >
                            <label className="lpops-seo-hero-email-cta-label" htmlFor="lpops-seo-hero-email">
                                Work email
                            </label>
                            <div className="lpops-seo-hero-email-cta-row">
                                <Mail size={20} className="lpops-seo-hero-email-icon" aria-hidden="true" />
                                <input
                                    id="lpops-seo-hero-email"
                                    type="email"
                                    name="email"
                                    autoComplete="email"
                                    inputMode="email"
                                    placeholder="Enter your work email"
                                    className="lpops-seo-hero-email-cta-input"
                                    value={heroEmail}
                                    disabled={isHeroEmailSubmitting}
                                    onChange={(changeEvent: React.ChangeEvent<HTMLInputElement>): void => {
                                        setHeroEmail(changeEvent.target.value);
                                    }}
                                />
                                <button
                                    type="submit"
                                    className="lpops-seo-hero-email-cta-button"
                                    disabled={isHeroEmailSubmitting}
                                >
                                    {isHeroEmailSubmitting ? 'Continuing...' : 'Create Your Free Account'}
                                    <ArrowRight size={19} aria-hidden="true" />
                                </button>
                            </div>
                            <TurnstileWidget
                                className="lpops-seo-hero-email-cta-turnstile lp-hot-intake-turnstile"
                                onTokenChange={setHeroCaptchaToken}
                                resetSignal={heroTurnstileResetSignal}
                            />
                        </form>
                    </div>

                    <p className="lpops-seo-hero-demo-link">
                        Prefer a walkthrough?{' '}
                        <button
                            type="button"
                            onClick={(): void => openWorkyCalendlyDemoInNewTab('lpops_seo_hero_book_demo', 'Book a Demo')}
                        >
                            Book a Demo
                        </button>
                    </p>

                    <div className={isMobile?'lph-review-holder-mobile':'lph-review-holder'}>
                        <Tooltip title="Rated 4.9/5 on G2 — loved by staffing & recruiting teams worldwide">
                            <div className='lph-review-item'>
                                <div className='lph-review-item-icon'><SiG2 size={20} color='#FF492C' /></div>
                                <div className='lph-review-item-rating'><Rating value={5} readOnly sx={{fontSize:17}}/></div>
                                <div className='lph-review-item-text'>4.9 Rating</div>
                            </div>
                        </Tooltip>
                        <Tooltip title="Join 150,000+ agency professionals already growing with Worky">
                            <div className='lph-review-item'>
                                <div className='lph-review-item-icon'><FaUsers size={20} color="#5a9bd6" /></div>
                                {/* <div className='lph-review-item-rating'></div> */}
                                <div className='lph-review-item-text'>+250k Users</div>
                            </div>
                        </Tooltip>
                        <Tooltip title="Rated Excellent on Trustpilot — agencies trust Worky to run their business">
                            <div className='lph-review-item'>
                                <div className='lph-review-item-icon'><SiTrustpilot size={20} color="#00B77F" /></div>
                                <div className='lph-review-item-rating'><Rating value={5} readOnly sx={{fontSize:17}}/></div>
                                <div className='lph-review-item-text'>4.9 Rating</div>
                            </div>
                        </Tooltip>
                    </div>
                    
                </div>
            </div>

            <div className={isMobile ? 'seo-demo-container-mobile' : 'seo-demo-container'}
                    ref={demoRef}
                    // className={isMobile ? 'hero-section-demo-mobile' : 'hero-section-demo'}
                    style={{
                        transform: isHoveringDemo
                            ? `perspective(900px) rotateX(${tiltX}deg) rotateY(${tiltY}deg)`
                            : `perspective(900px) rotateX(${demoRotation}deg)`,
                        transition: isHoveringDemo
                            ? 'transform 0.06s ease-out'
                            : 'transform 0.45s ease-out',
                    }}
                    onMouseMove={handleDemoMouseMove}
                    onMouseEnter={handleDemoMouseEnter}
                    onMouseLeave={handleDemoMouseLeave}
                >
            {isMobile ? <WorkyMainDemoMobile /> : <WorkyMainDemo />}
            </div>


            {/* 4. Image/Bottom Container */}
            {/* <div className={isMobile ? 'lpop-hero-image-container-mobile' : 'lpop-hero-image-container'}>
                <div className='lpop-hero-image-container-short'>
                    
                    
                    <div className='lpop-hero-image-container-short-inner'>
                        <div className='lpop-hero-image-container-short-inner-icon'><ClockPlus size={25} /></div>
                        <div className='lpop-hero-image-container-short-inner-text-holder'>
                            <div className='lpop-hero-image-container-short-inner-text-holder-title'>$250M in Payroll</div>
                            <div className='lpop-hero-image-container-short-inner-text-holder-subtitle'>Powered by Worky</div>
                        </div>
                    </div>
                    
                    
                    <div className='lpop-hero-image-container-short-inner'>
                        <div className='lpop-hero-image-container-short-inner-icon'><DollarSign size={25} /></div>
                        <div className='lpop-hero-image-container-short-inner-text-holder'>
                            <div className='lpop-hero-image-container-short-inner-text-holder-title'>$52,000+</div>
                            <div className='lpop-hero-image-container-short-inner-text-holder-subtitle'>Anual cost savings</div>
                        </div>
                    </div>
                    
                    
                    <div className='lpop-hero-image-container-short-inner'>
                        <div className='lpop-hero-image-container-short-inner-icon'><ChartNoAxesCombined  size={25} /></div>
                        <div className='lpop-hero-image-container-short-inner-text-holder'>
                            <div className='lpop-hero-image-container-short-inner-text-holder-title'>85%</div>
                            <div className='lpop-hero-image-container-short-inner-text-holder-subtitle'>Efficiency gain</div>
                        </div>
                    </div>

                </div>

               
                <MainProductsContainer isMobile={isMobile}/>

            </div> */}


        </div>
    )
}



// const MainProductsContainer = ({isMobile}: {isMobile: boolean}) => {
//     return(
//         <div className={`lpsp-main-products-container lpsp-operations-main-products ${isMobile ? 'is-mobile' : ''}`}>
//                 <div className={isMobile ? 'lp-blog-title-mobile' : 'lp-blog-title'}>The modern operating system for healthcare staffing software &amp; home care staffing software</div>
//                 <div className={isMobile ? 'lpsp-hero-subtitle-mobile' : 'lpsp-hero-subtitle'}>Worky is the industry-leading all-in-one healthcare staffing software and home care staffing software platform, trusted by the fastest-growing agencies. </div>
//                 <button className={isMobile ? 'lpsp-hero-button-mobile' : 'lpsp-hero-button'}>Make the Switch</button>
//                 <div className={isMobile ? 'lpsp-main-products-container-cards-mobile lpsp-operations-product-cards-mobile' : 'lpsp-main-products-container-cards lpsp-operations-product-cards'}>

                    
//                         <div 
//                             className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
//                             onClick={() => scrollToSection({ sectionId: 'invoicing', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
//                             style={{cursor: 'pointer'}}
//                         >
                                            
//                             <div className='lp-product-img-container'>
//                                 <InvoicingSelectionIllustration />
//                             </div>

//                             <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
//                                 <div className='lp-product-label'>
//                                     <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Receipt size={isMobile ? 18 : 20} /></span>
//                                     <span className='lp-product-label-text'>Invoicing</span>
//                                 </div>
//                                 <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Automated client billing—customized to every contract</div>
//                             </div>
                            
//                             <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                        
//                         </div>

         


//                         <div 
//                             className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
//                             onClick={() => scrollToSection({ sectionId: 'worky-pay', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
//                             style={{cursor: 'pointer'}}
//                         >
                                            
//                             <div className='lp-product-img-container'>
//                                 <WorkypaySelectionIllustration />
//                             </div>

//                             <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
//                                 <div className='lp-product-label'>
//                                     <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><HandCoins size={isMobile ? 18 : 20} /></span>
//                                     <span className='lp-product-label-text'>Worky Pay</span>
//                                 </div>
//                                 <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Flexible payroll for your contractors and employees</div>
//                             </div>
                            
//                             <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                        
//                         </div>

//             {/* *************************************************************************************************************************************************************** */}



//                         <div 
//                             className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
//                             onClick={() => scrollToSection({ sectionId: 'smart-match', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
//                             style={{cursor: 'pointer'}}
//                         >
                                            
//                             <div className='lp-product-img-container'>
//                                 <SmartMatchSelectionIllustration />
//                             </div>

//                             <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
//                                 <div className='lp-product-label'>
//                                     <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Combine size={isMobile ? 18 : 20} /></span>
//                                     <span className='lp-product-label-text'>Smart Match</span>
//                                 </div>
//                                 <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>AI-driven placement that never sleeps.</div>
//                             </div>
                            
//                             <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                        
//                         </div>

//             {/* *************************************************************************************************************************************************************** */}


//                         <div 
//                             className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
//                             onClick={() => scrollToSection({ sectionId: 'time-clock', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
//                             style={{cursor: 'pointer'}}
//                         >
                                            
//                             <div className='lp-product-img-container'>
//                                 <TimeClockSelectionIllustration />
//                             </div>

//                             <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
//                                 <div className='lp-product-label'>
//                                     <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><MapPinned size={isMobile ? 18 : 20} /></span>
//                                     <span className='lp-product-label-text'>Time Clock</span>
//                                 </div>
//                                 <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Digital tracking driving automated pay & billing</div>
//                             </div>
                            
//                             <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                        
//                         </div>

//             {/* *************************************************************************************************************************************************************** */}


//                         <div 
//                             className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
//                             onClick={() => scrollToSection({ sectionId: 'workforce', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
//                             style={{cursor: 'pointer'}}
//                         >
                                            
//                             <div className='lp-product-img-container'>
//                                 <WorkforceSelectionIllustration />
//                             </div>

//                             <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
//                                 <div className='lp-product-label'>
//                                     <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><Contact size={isMobile ? 18 : 20} /></span>
//                                     <span className='lp-product-label-text'>Workyforce</span>
//                                 </div>
//                                 <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Centralized hub for every worker in your talent pool</div>
//                             </div>
                            
//                             <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                        
//                         </div>

//             {/* *************************************************************************************************************************************************************** */}


//                         <div 
//                             className={isMobile ? 'lp-products-available-product-mobile' : 'lp-products-available-product'}
//                             onClick={() => scrollToSection({ sectionId: 'trust-vault', allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS], offset: isMobile ? 70 : 80, behavior: 'smooth' })}
//                             style={{cursor: 'pointer'}}
//                         >
                                            
//                             <div className='lp-product-img-container'>
//                                 <TrustVaultSelectionIllustration />
//                             </div>

//                             <div className={isMobile ? 'lp-product-content-mobile' : 'lp-product-content'}>
//                                 <div className='lp-product-label'>
//                                     <span className={isMobile ? 'lp-product-label-icon-mobile' : 'lp-product-label-icon'} style={{background:'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)'}}><BookLock size={isMobile ? 18 : 20} /></span>
//                                     <span className='lp-product-label-text'>Trust Vault</span>
//                                 </div>
//                                 <div className={isMobile ? 'lp-product-title-mobile' : 'lp-product-title'}>Secure credential and document management</div>
//                             </div>
                            
//                             <button className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}><ChevronRight size={isMobile ? 18 : 20} style={{transform: 'rotate(90deg)'}} /></button>
                        
//                         </div>

//             {/* *************************************************************************************************************************************************************** */}




//                 </div>
//             </div>
//     )
// }


// const OperationsSeoOverview = ({ isMobile }: OperationsSeoOverviewProps): React.JSX.Element => {
//     return (
//         <section
//             id="overview"
//             className={`lpops-seo-overview ${isMobile ? 'is-mobile' : ''}`}
//             aria-labelledby="lpops-seo-overview-heading"
//         >
//             <h2 id="lpops-seo-overview-heading">
//                 Why agencies choose Worky healthcare staffing software
//             </h2>
//             <p>
//                 Spreadsheet scheduling, disconnected time clocks, and manual billing slow healthcare
//                 and home care agencies down. Worky consolidates the operating system agencies need
//                 so coordinators can place qualified workers faster, verify hours accurately, pay
//                 on time, and invoice clients from approved work.
//             </p>
//             <p>
//                 Use this page to explore the full Operations Suite: Invoicing, Worky Pay, Time Clock,
//                 Smart Match, Workforce, and Trust Vault—the same product surface agencies use to run
//                 day-to-day staffing operations.
//             </p>
//             <ul>
//                 <li>Reduce no-shows and mismatched placements with AI-assisted Smart Match</li>
//                 <li>Verify attendance with location-aware Time Clock events</li>
//                 <li>Run contractor and employee payroll with Worky Pay</li>
//                 <li>Generate client invoices from approved hours and contract rules</li>
//                 <li>Track credentials and compliance documents in Trust Vault</li>
//             </ul>
//         </section>
//     );
// };

interface OperationsSeoFaqProps {
    readonly isMobile: boolean;
}

const OperationsSeoFaq = ({ isMobile }: OperationsSeoFaqProps): React.JSX.Element => {
    return (
        <section
            id="faq"
            className={`lpops-seo-faq ${isMobile ? 'is-mobile' : ''}`}
            aria-labelledby="lpops-seo-faq-heading"
        >
            <div className="lpops-seo-faq-intro">
                <h2 id="lpops-seo-faq-heading">Frequently Asked Questions</h2>
                <p>
                    Quick answers to questions you may have about Worky healthcare and homecare staffing software.
                    Can&apos;t find what you&apos;re looking for? Check out our resources or talk with our team.
                </p>
                <div className="lpops-seo-faq-actions">
                    <a className="lpops-seo-faq-button is-secondary" href={WORKY_WEB_APP_PATHS.landingPageBlog}>
                        <BookOpen size={16} aria-hidden="true" />
                        Resources
                    </a>
                    <button type="button" className="lpops-seo-faq-button is-primary" onClick={navigateToContactSalesPage}>
                        <Headphones size={16} aria-hidden="true" />
                        Get in touch
                    </button>
                </div>
            </div>
            <div className="lpops-seo-faq-list">
                {OPERATIONS_SEO_FAQS.map(
                    (faq: { readonly question: string; readonly answer: string }, index: number): React.JSX.Element => (
                        <details key={faq.question} className="lpops-seo-faq-item" open={index === 0}>
                            <summary>
                                <ChevronDown className="lpops-seo-faq-chevron" size={18} aria-hidden="true" />
                                <span>{faq.question}</span>
                            </summary>
                            <p>{faq.answer}</p>
                        </details>
                    )
                )}
            </div>
        </section>
    );
};


interface NumberOneSoftwareProps {
    readonly isMobile: boolean;
}

const NUMBER_ONE_SOFTWARE_LINES_DESKTOP: readonly string[] = [
    'Worky is the #1 operations system modern and growing',
    'home care and healthcare businesses prefer to run on.',
    'Schedule shifts, manage care plans, verify time, stay',
    'compliant, run payroll, and invoice clients from one',
    ' platform.',
    'Built for teams that are scaling, not stitching spreadsheets',
    ' together.',
];

const NUMBER_ONE_SOFTWARE_LINES_MOBILE: readonly string[] = [
    'Worky is the #1',
    'operations system',
    'modern and',
    'growing',
    'home care and',
    'healthcare',
    'businesses prefer to',
    'run on.',
    'Schedule shifts,',
    'manage care',
    'plans, verify time,',
    'stay compliant,',
    'run payroll, and',
    'invoice clients',
    'from one platform.',
    'Built for teams that',
    'are scaling, not',
    'stitching',
    'spreadsheets',
    'together.',
];

const getNumberOneSoftwareLines = (isMobile: boolean): readonly string[] => {
    return isMobile ? NUMBER_ONE_SOFTWARE_LINES_MOBILE : NUMBER_ONE_SOFTWARE_LINES_DESKTOP;
};

const getScrollFillProgress = (elementTop: number, viewportHeight: number, isMobile: boolean): number => {
    const start: number = viewportHeight * (isMobile ? 0.5 : 1);
    const end: number = viewportHeight * -0.55;
    const rawProgress: number = (start - elementTop) / (start - end);
    return Math.max(0, Math.min(1, rawProgress));
};

const getLineFillProgress = (overallProgress: number, lineIndex: number, lineCount: number): number => {
    const start: number = lineIndex / lineCount;
    const end: number = (lineIndex + 1) / lineCount;
    if (overallProgress <= start) {
        return 0;
    }
    if (overallProgress >= end) {
        return 1;
    }
    return (overallProgress - start) / (end - start);
};

interface NumberOneSoftwareLineProps {
    readonly text: string;
    readonly fillProgress: number;
}

const NumberOneSoftwareLine = ({ text, fillProgress }: NumberOneSoftwareLineProps): React.JSX.Element => {
    const clampedProgress: number = Math.max(0, Math.min(1, fillProgress));
    const fillStop: string = `${clampedProgress * 100}%`;

    return (
        <span
            className="number-one-software-line"
            style={{
                backgroundImage: `linear-gradient(90deg, var(--text-colour) ${fillStop}, var(--launch-highlight) ${fillStop})`,
            }}
        >
            {text}
        </span>
    );
};

const NumberOneSoftware = ({ isMobile }: NumberOneSoftwareProps): React.JSX.Element => {
    const headingRef = useRef<HTMLHeadingElement>(null);
    const [scrollProgress, setScrollProgress] = useState<number>(0);

    useEffect((): (() => void) => {
        const updateProgress = (): void => {
            const headingElement: HTMLHeadingElement | null = headingRef.current;
            if (!headingElement) {
                return;
            }
            setScrollProgress(getScrollFillProgress(headingElement.getBoundingClientRect().top, window.innerHeight, isMobile));
        };

        updateProgress();
        window.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);
        return (): void => {
            window.removeEventListener('scroll', updateProgress);
            window.removeEventListener('resize', updateProgress);
        };
    }, [isMobile]);

    const softwareLines: readonly string[] = getNumberOneSoftwareLines(isMobile);

    return (
        <section
            className={`number-one-software ${isMobile ? 'is-mobile' : ''}`}
            aria-labelledby="number-one-software-heading"
        >
            <h2 id="number-one-software-heading" ref={headingRef}>
                {softwareLines.map((line: string, index: number): React.JSX.Element => (
                    <React.Fragment key={`${isMobile ? 'mobile' : 'desktop'}-${index}`}>
                        {index > 0 && (!isMobile || softwareLines[index - 1]?.endsWith('.')) ? (
                            <span aria-hidden="true" style={{ display: 'block', height: '0.6em' }} />
                        ) : null}
                        <NumberOneSoftwareLine
                            text={line}
                            fillProgress={getLineFillProgress(scrollProgress, index, softwareLines.length)}
                        />
                    </React.Fragment>
                ))}
            </h2>
            {/* <ul className="number-one-software-proof" aria-label="Worky social proof">
                <li>
                    <SiG2 size={18} color="#FF492C" aria-hidden="true" />
                    <strong>4.9</strong>
                    <span>G2 rating</span>
                </li>
                <li>
                    <SiTrustpilot size={18} color="#00B77F" aria-hidden="true" />
                    <strong>4.9</strong>
                    <span>Trustpilot rating</span>
                </li>
                <li>
                    <FaUsers size={18} color="#5a9bd6" aria-hidden="true" />
                    <strong>+250k</strong>
                    <span>agency users</span>
                </li>
            </ul> */}
        </section>
    );
};

const LandingPageProductsOperationsSeo = (): React.JSX.Element => {
    const isMobile: boolean = useIsMobile();
    useLandingPageSeo(landingPageSeoByPath[OPERATIONS_SEO_PATH]);

    const [isSideNavVisible, setIsSideNavVisible] = useState<boolean>(false);
    const [activeSection, setActiveSection] = useState<string | null>(null);
    const [isOperationsProductModalOpen, setIsOperationsProductModalOpen] = useState<boolean>(false);
    const [selectedOperationsProductKey, setSelectedOperationsProductKey] =
        useState<OperationsProductKey | null>(null);

    const handleOperationsHashScroll = useCallback((): void => {
        if (!isOperationsLandingPath(window.location.pathname)) {
            return;
        }

        const sectionId: string = window.location.hash?.replace('#', '') ?? '';
        if (!sectionId) {
            return;
        }

        const supportedSections: ReadonlySet<string> = new Set<string>([
            ...OPERATIONS_SECTION_IDS,
            'overview',
            'faq',
            'top',
        ]);
        if (!supportedSections.has(sectionId)) {
            return;
        }

        setTimeout((): void => {
            scrollToSection({
                sectionId,
                allowedPaths: [...OPERATIONS_SCROLL_ALLOWED_PATHS],
                offset: isMobile ? 70 : 80,
                behavior: 'smooth',
            });
        }, 100);
    }, [isMobile]);

    useEffect((): (() => void) => {
        handleOperationsHashScroll();
        window.addEventListener('hashchange', handleOperationsHashScroll);
        return (): void => window.removeEventListener('hashchange', handleOperationsHashScroll);
    }, [handleOperationsHashScroll]);

    useEffect((): (() => void) => {
        let rafId: number | null = null;

        const updateVisibility = (): void => {
            const sectionEls: readonly (HTMLElement | null)[] = OPERATIONS_SECTION_IDS.map(
                (id: string): HTMLElement | null => document.getElementById(id)
            );
            const firstEl: HTMLElement | null = sectionEls[0] ?? null;
            if (!firstEl) {
                return;
            }

            const tops: readonly number[] = sectionEls.map((el: HTMLElement | null): number =>
                el ? el.getBoundingClientRect().top + window.pageYOffset : Number.POSITIVE_INFINITY
            );
            const firstTop: number = tops[0] ?? Number.POSITIVE_INFINITY;
            const shouldShow: boolean = window.pageYOffset >= firstTop - 400;
            setIsSideNavVisible((prev: boolean): boolean => (prev === shouldShow ? prev : shouldShow));

            if (!shouldShow) {
                setActiveSection((prev: string | null): string | null => (prev === null ? prev : null));
                return;
            }

            const y: number = window.pageYOffset + 220;
            let nextActive: string | null = null;
            for (let i: number = OPERATIONS_SECTION_IDS.length - 1; i >= 0; i -= 1) {
                const topValue: number | undefined = tops[i];
                if (topValue !== undefined && y >= topValue - 10) {
                    nextActive = OPERATIONS_SECTION_IDS[i] ?? null;
                    break;
                }
            }
            setActiveSection((prev: string | null): string | null =>
                prev === nextActive ? prev : nextActive
            );
        };

        const onScroll = (): void => {
            if (rafId) {
                return;
            }
            rafId = window.requestAnimationFrame((): void => {
                rafId = null;
                updateVisibility();
            });
        };

        updateVisibility();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', updateVisibility);
        return (): void => {
            if (rafId) {
                window.cancelAnimationFrame(rafId);
            }
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', updateVisibility);
        };
    }, []);

    return (
        <>
            <LandingNavigation />
            <main className={OPERATIONS_SEO_PAGE_CLASS}>
                <OperationsSeoHero isMobile={isMobile} />
                {/* <OperationsSeoOverview isMobile={isMobile} /> */}
                {/* <OperationsHero isMobile={isMobile} /> */}
                {/* Temporarily hidden: #1 operations system text block */}
                {/* <NumberOneSoftware isMobile={isMobile} /> */}
                <InvoicingContainer isMobile={isMobile} />
                <WorkyPayContainer isMobile={isMobile} />
                <TimeClockContainer isMobile={isMobile} />
                <SmartMatchContainer isMobile={isMobile} />
                <WorkforceContainer isMobile={isMobile} />
                <TrustVaultContainer isMobile={isMobile} />
                <OperationsSeoFaq isMobile={isMobile} />
                <OperationsProductModal
                    open={isOperationsProductModalOpen}
                    productKey={selectedOperationsProductKey}
                    onClose={(): void => {
                        setIsOperationsProductModalOpen(false);
                        setSelectedOperationsProductKey(null);
                    }}
                />
                <SideNavigationBar
                    isMobile={isMobile}
                    isVisible={isSideNavVisible}
                    activeSection={activeSection}
                />
                <LPFooter isMobile={isMobile} />
            </main>
        </>
    );
};

export { LandingPageProductsOperationsSeo };
